import i18n from "@/libs/i18n";

export default [
  {
    get header() {
      return i18n.t("surgery.surgery");
    },
    permission: "get-surgery",
    role: "Surgery",
  },
  {
    get title() {
      return i18n.t("surgery.surgery-dashboard");
    },
    route: "surgery",
    icon: "PlusSquareIcon",
    permission: "get-surgery",
    role: "Surgery",
  },
  {
    get title() {
      return i18n.t("reception.patient-surgery");
    },
    route: "surgery-patient",
    icon: "BarChart2Icon",
    permission: "store-surgery",
    role: "Surgery",
  },
  {
    get title() {
      return i18n.t("surgery.surgery-patient-history");
    },
    route: "surgery-patient-history",
    icon: "PlusSquareIcon",
    permission: "get-surgery",
    role: "Surgery",
  },
];
